import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleNonFinal: {
		id: 'periscope.header.title-non-final',
		defaultMessage: 'Development',
		description:
			'This is the page title for the development page. This page is where users (developers) see their work suggestions.',
	},
});
